import {Fragment} from "preact";
import s from "./progressBar.module.css";
import Bullet from "./Bullet";

const ProgressBar = (props) => {
    // Destructured props
    const {
        stepsAmount = 5,
        currentStep = 0
    } = props;

    // A mapped array containing the bullet for each step of the survey
    const bullets =
        Array.from(Array(stepsAmount).keys()).map(step => {
            return (
                <Bullet
                    key={step}
                    currentStep={currentStep}
                    stepsAmount={stepsAmount}
                    step={step + 1}
                />
            )
        })

    // The variable name already says it all
    const content = currentStep <= stepsAmount ? (
        <div className={s.root}>
            {bullets}
        </div>
    ) : null;

    return (
        <Fragment>
            {content}
        </Fragment>
    )
}

export default ProgressBar;
